/** @format */

import { Injectable } from '@angular/core';
import { BranchIoDao } from './branch-io.dao';
import { Observable } from 'rxjs';
import { BranchIoResponse, DeepLinkOptions } from '@shared/data-access/interfaces';
@Injectable({
  providedIn: 'root',
})
export class DeepLinkingService {
  constructor(private branchIoDao: BranchIoDao) {}

  public createDeepLink(options: DeepLinkOptions): Observable<BranchIoResponse> {
    return this.branchIoDao.createDeepLink(options);
  }
}
